import { Injectable, RendererFactory2, ViewEncapsulation, Inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { LinkService } from '../seoservice/link.service';
import { ScullyRoutesService } from '@scullyio/ng-lib';
import { environment } from '@env/environment';
import { PlanSEO } from 'src/app/models/plan.model';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  infoPlans: PlanSEO[] = [
    {
      clientType: '1',
      title: 'Planes de publicación de inmuebles para inmobiliarias',
      description: 'Encuentra aquí los diferentes planes que tenemos para inmobiliarias: Beneficios, costos, visualización y las facilidades que ofrece publicar en Ciencuadras.',
      canonical: 'productos/seleccion-ideal/inmobiliaria'
    },
    {
      clientType: '2',
      title: 'Planes de publicación para agentes inmobiliarios',
      description: 'Encuentra aquí los diferentes planes que tenemos para agentes inmobiliarios: Beneficios, costos, visualización y lo fácil que es publicar en Ciencuadras.',
      canonical: 'productos/seleccion-ideal/agente-inmobiliario'
    },
    {
      clientType: '3',
      title: 'Planes de publicación proyectos de vivienda para constructores',
      description: 'Encuentre aquí los diferentes planes que tenemos para constructores: Beneficios, costos y como incrementar la visualización de sus proyectos de vivienda.',
      canonical: 'productos/seleccion-ideal/constructora'
    }
  ];


  constructor(private titleService:Title,
    private metaService: Meta,
    private linkServices: LinkService,
    private scully: ScullyRoutesService,) { }

    insertSEO(textTitle:string, description:string,route:string, gsv: string = 'FA6V-6fu2AtQmqrjGNS7o7yo4encsT8obvf4uj6808'){
        this.scully.getCurrent().subscribe(link=>{
          this.linkServices.removeTag('rel="canonical"');
          if(environment.production){
            this.metaService.updateTag( { name:'robots',content:"index, follow"});
          }else {
            this.metaService.updateTag( { name:'robots',content:"noindex, nofollow"});
          }
          this.metaService.updateTag( { name:'google-site-verification',content: gsv});
          this.metaService.updateTag( { name:'description',content:description});
          this.titleService.setTitle(textTitle);
          this.metaService.updateTag( { name:'language',content:"Spanish"});
          this.metaService.updateTag( { name:'geo.region',content:"CO"});
          this.metaService.updateTag( { name:'geo.position',content:"4.570868;-74.297333"});
          this.metaService.updateTag( { name:'ICBM',content:"4.570868, -74.297333"});
          this.linkServices.addTag( {rel:'canonical',href:'https://www.ciencuadras.com/'+route});
          this.metaService.updateTag( { property:'og:title',content:textTitle});
          this.metaService.updateTag( { property:'og:description',content:description});
    
          this.metaService.updateTag( { property:'og:url',content:"https://www.ciencuadras.com/"+route});
          this.metaService.updateTag( { property:'og:image',content:"https://www.ciencuadras.com/assets/images/ciencuadras.png"});
          this.metaService.updateTag( { property:'og:site_name',content:"Ciencuadras"});
          this.metaService.updateTag( { property:'og:type',content:"website"});
          this.metaService.updateTag( { property:'og:locale',content:"es_CO"});
          this.metaService.updateTag( { property:'fb:admins',content:"103588883010114"});
          this.metaService.updateTag( { name:'theme-color',content:"#3e98cc"});

          /** Metatags Twitter */
          this.metaService.updateTag( { property: 'twitter:title', content: textTitle } );
          this.metaService.updateTag( { property: 'twitter:description', content: description } );
          this.metaService.updateTag( { property: 'twitter:url', content: "https://www.ciencuadras.com/" + route } );
          this.metaService.updateTag( { property: 'twitter:creator', content: '@ciencuadras' } );
          this.metaService.updateTag( { property: 'twitter:card', content: 'summary_large_image' } );
          this.metaService.updateTag( { property: 'twitter:site', content: 'ciencuadras.com' } );
          this.metaService.updateTag( { property: 'twitter:image', content: 'https://www.ciencuadras.com/assets/images/ciencuadras.png' } );
        });
    
      }

    insertSEOByClientType(clientType: string) {
      const filteredInfoPlans = this.infoPlans.filter(plan => plan.clientType === clientType);
      this.insertSEO(`${filteredInfoPlans[0].title} | Ciencuadras`, filteredInfoPlans[0].description, filteredInfoPlans[0].canonical, 'oFA6V-6fu2AtQmqrjGNS7o7yo4encsT8obvf4uj6808');
    }


}



